import SmartPhoto from 'smartphoto';

// クリック時の最低拡大率
const MIN_ZOOM_SCALE = 1.5;

export default class Sokanzu {
    constructor() {
        this.init();
    }

    init() {
        this._createViewer();
    }

    _createViewer() {
        // 開く演出を相関図の比率で行うための起点画像
        const photo = document.querySelector('.js-smartPhoto');
        photo.insertAdjacentHTML('afterbegin', `<img src="${photo.href}" alt="" class="mainlist__subnav__origin">`);

        this.photo = new SmartPhoto('.js-smartPhoto', {
            arrows: false,
            nav: false,
        });

        // クリック時は横幅・縦幅いっぱいの大きい方まで拡大（最低拡大率あり）
        this.photo._getScaleBoarder = () => {
            const { width, height, scale } = this.photo._getSelectedItem();
            const fitWidth = this.photo._getWindowWidth() / (width * scale);
            const fitHeight = this.photo._getWindowHeight() / (height * scale);
            return Math.max(fitWidth, fitHeight, MIN_ZOOM_SCALE);
        };
    }
}
